import { Grid } from "@mui/material";

import { EntityInput } from "@dzambalaorg/mui-inputs-entity";
import { SearchWithFilters } from "@dzambalaorg/mui-form-search";

export const PredictionAnswerSearchForm = () => {
  return (
    <SearchWithFilters initialValues={{ questionIds: [] }}>
      <Grid container spacing={2} alignItems="flex-end">
        <Grid size={{ xs: 12 }}>
          <EntityInput multiple name="questionIds" controller="prediction/questions" />
        </Grid>
      </Grid>
    </SearchWithFilters>
  );
};
